<template>
  <div>
    <div v-if="loading">
      <amenity-manatee-loading></amenity-manatee-loading>
    </div>
    <div v-else>
      <dl class="dashboard-dl">
        <div class="container-fluid">
          <div>
            <span v-if="!this.priceInterval.EndDate && this.priceInterval.PriceIntervalStatusId === 4"
              class="label label-success">Newest</span>
            <span v-if="this.isCurrent === true" class="label label-warning">Current</span>
            <span v-if="this.isScheduled === true" class="label label-danger">Scheduled</span>
          </div>
          <div v-if="show_community">
            <div class="row">
              <div class="col-sm-6">
                <dt>Community</dt>
                <dd>
                  <a :href="this.priceInterval.CommunityUrl">
                    {{ this.priceInterval.Community }}
                  </a>
                </dd>
              </div>
              <div class="col-sm-6">
                <dt>Package Price</dt>
                <dd>{{ this.priceInterval.PackagePriceName }}</dd>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <dt>Amount</dt>
              <dd>${{ this.priceInterval.Amount }}</dd>
            </div>
            <div class="col-sm-6">
              <dt>Status</dt>
              <dd>{{ this.priceInterval.PriceIntervalStatus }}
                <i class="fa fa-info-circle text-gray tool-tip"><span class="tool-tip-text">{{
                  this.priceInterval.PriceIntervalStatusDescription }}</span></i>
              </dd>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <dt>Start Date</dt>
              <dd>{{ $options.filters.date(this.priceInterval.StartDate) }}</dd>
            </div>
            <div class="col-sm-6">
              <dt>End Date</dt>
              <dd>{{ $options.filters.date(this.priceInterval.EndDate) }}</dd>
            </div>
          </div>
          <div v-if="this.priceInterval.PackagePriceTypeId === 1" class="row">
            <div class="col-sm-6">
              <dt>Renewal Start Date</dt>
              <dd>
                {{ $options.filters.date(this.priceInterval.RenewalStartDate) }}
              </dd>
            </div>
          </div>
          <div
            v-if="this.priceInterval.PriceIntervalStatusId !== 4 && this.priceInterval.PriceIntervalStatusId !== 5 && this.priceInterval.PriceIntervalStatusId !== 6"
            class="row">
            <div class="col-sm-12 text-right">
              <button type="button" class="btn btn-primary" id="open-modal" @click="openModal">
                Edit
              </button>
            </div>
          </div>
          <div class="row">
            <div class="panel panel-default" style="
                border: 1px solid #ccc;
                background-color: white;
                margin-top: 25px;
              ">
              <div class="panel-heading">
                <h4 class="panel-title">
                  <a href="javascript://void(0)" @click="toggleShowAll">
                    <i v-if="collapseSection" class="fa fa-angle-right" aria-hidden="true"></i>
                    <i v-else class="fa fa-angle-down" aria-hidden="true"></i>
                    Status Notes
                  </a>
                </h4>
              </div>
              <div class="panel-collapse" :class="{ collapse: this.collapseSection }" style="background-color: white">
                <div class="panel-body" style="background-color: white">
                  <ul>
                    <li v-for="priceIntervalStatusNote in this.priceInterval
                      .PriceIntervalStatusNotes" :key="priceIntervalStatusNote.Id">
                      {{ priceIntervalStatusNote.PriceIntervalStatus }}:
                      {{ priceIntervalStatusNote.NoteText }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <modal :name="modalName" :adaptive="true" :scrollable="true" height="auto" style="padding: 3rem 0 6rem 0">
          <form @submit.prevent="save" method="POST" accept-charset="UTF-8" class="margin-md-top"
            enctype="multipart/form-data" novalidate="novalidate">
            <div class="dashboard-block" :class="{ loading: loading }">
              <header>
                <div class="row form-group">
                  <div class="col-sm-8">
                    <h4>
                      <span>{{ this.priceInterval.PackagePriceName }}</span>
                    </h4>
                    <h5>{{ this.priceInterval.PackagePriceType }}</h5>
                    <h6>
                      <a :href="this.priceInterval.CommunityUrl">
                        Community:{{ this.priceInterval.Community }}
                      </a>
                    </h6>
                  </div>

                  <div class="col-sm-4 text-right">
                    <button type="button" class="btn btn-primary" id="close-modal" @click="closeModal">
                      <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </header>
              <legend>Price Interval</legend>
              <div class="row">
                <div class="col-sm-6 form-group">
                  <label for="price-start-date">Start Date</label>

                  <input id="price-start-date" type="date" class="form-control" v-model="priceInterval.StartDate"
                    v-validate="'required'" name="Start Date" />
                  <span v-show="errors.has('Start Date')" class="help-block">
                    {{ errors.first("Start Date") }}
                  </span>
                </div>
                <div class="col-sm-6 form-group has-feedback" :class="{ 'has-error': errors.has('Amount') }">
                  <label for="price-amount">Amount</label>
                  <div class="input-group">
                    <span class="input-group-addon">$</span>
                    <input id="price-amount" type="number" class="form-control" v-model="priceInterval.Amount"
                      v-validate="'required|between:0,300'" name="Amount" />
                    <span v-show="errors.has('Amount')" class="help-block">
                      {{ errors.first("Amount") }}
                    </span>
                  </div>
                </div>
              </div>
              <div v-if="this.priceInterval.PackagePriceTypeId === 1" class="row">
                <div class="col-sm-6 form-group">
                  <label for="price-renewal-start-date">Renewal Start Date</label>

                  <input id="price-renewal-start-date" type="date" class="form-control"
                    v-model="priceInterval.RenewalStartDate" v-validate="'required'" name="Renewal Start Date" />
                  <span v-show="errors.has('Renewal Start Date')" class="help-block">
                    {{ errors.first("Renewal Start Date") }}
                  </span>
                </div>
              </div>

              <div class="row form-group">
                <div class="col-sm-6"></div>
                <div class="col-sm-6 text-right">
                  <button type="button" class="btn btn-success" id="save-modal" @click="save(false)"
                    :disabled="hasErrors || disableButtons">
                    Save
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 form-group">
                  <label for="note">Note for
                    {{ this.priceInterval.PriceIntervalStatus }} Status</label>
                  <div class="input-group">
                    <textarea id="note" class="form-control" v-model="priceInterval.CurrentStatusNote"
                      v-validate="needsNote" name="Note" placeholder="add multiple lines" rows="4" cols="100"></textarea>
                    <span v-show="errors.has('Note')" class="help-block">
                      {{ errors.first("Note") }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="row form-group">
                <div class="col-sm-3 text-left">
                  <button type="button" class="btn btn-primary" id="reject-btn" @click="reject"
                    :disabled="disableButtons">
                    Reject
                  </button>
                </div>
                <div class="col-sm-9 text-right">
                  <button type="button" class="btn btn-warning" id="save-modal" @click="save(true)"
                    :disabled="hasErrors || disableButtons">
                    Move to {{ this.priceInterval.NextStatus }}
                  </button>
                </div>
              </div>
              <div v-if="this.priceInterval.CanRevert" class="row form-group">
                <div class="col-sm-12 text-right">
                  <button type="button" class="btn btn-primary" id="revert-btn" @click="revert"
                    :disabled="disableButtons">
                    Revert
                  </button>
                </div>
              </div>

              <span class="help-block">
                <ul>
                  <li v-for="postError in this.postErrors" :key="postError">
                    {{ postError }}
                  </li>
                </ul>
              </span>
            </div>
          </form>
        </modal>
      </dl>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: {
    price_interval_id: {
      required: true,
      type: Number,
    },
    show_community: {
      required: true,
      type: Boolean,
    },
    price_interval: {
      required: false,
      type: Object,
      default: null,
    }
  },
  mounted() {
    this.loadPriceInterval();
  },

  methods: {

    beforeLoad() {
      return this.loadPriceInterval();
    },
    loadPriceInterval() {
      if (this.price_interval !== null && this.priceInterval === null) {
        this.$set(this, "priceInterval", this.price_interval);
        this.updateDates();
        this.loading = false;
        return function () { return; };
      }
      var url = "/core/priceInterval/" + this.price_interval_id;
      console.log(url);
      return axios.get(url).then((response) => {
        //console.log(response.data.PriceInterval);

        this.$set(this, "priceInterval", response.data.PriceInterval);
        this.updateDates();
        this.loading = false;
        this.postErrors = null;
      }).catch(this.$root.handleErrors)
        .finally(() => {
          this.loading = false;


        });
    },
    updateDates() {
      var currentDate = new Date();
      this.isScheduled = moment.utc(this.priceInterval.StartDate) > currentDate && this.priceInterval.PriceIntervalStatusId === 4;
      this.isCurrent = moment.utc(this.priceInterval.StartDate) <= currentDate && (moment.utc(this.priceInterval.EndDate) >= currentDate || this.priceInterval.EndDate === null) && this.priceInterval.PriceIntervalStatusId === 4;
      this.priceInterval.StartDate = moment
        .utc(this.priceInterval.StartDate)
        .format("YYYY-MM-DD");
      if (this.priceInterval.RenewalStartDate !== null) {
        this.priceInterval.RenewalStartDate = moment
          .utc(this.priceInterval.RenewalStartDate)
          .format("YYYY-MM-DD");
      }
    },
    openModal() {
      this.$modal.show(this.modalName);
    },
    closeModal() {
      this.$modal.hide(this.modalName);
    },
    toggleShowAll() {
      this.collapseSection = !this.collapseSection;
    },
    reject() {
      this.disableButtons = true;
      var url = "/core/priceInterval/" + this.priceInterval.Id + "/reject";
      axios
        .post(url)
        .then((response) => {
          //console.error(response.data.PackagePrice);
          this.$notify({
            type: "success",
            placement: "top-left",
            title: "Saved Price Interval Successfully",
          });
          this.closeModal();
          this.loading = true;
          this.loadPriceInterval();
        })
        .catch((error) => {
          if (error.response) {
            this.updatePostErrors(error.response.data.errors);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
        })
        .finally(() => {
          this.disableButtons = false;
        });
    },
    revert() {
      this.disableButtons = true;
      var url = "/core/priceInterval/" + this.priceInterval.Id + "/revert";
      axios
        .post(url)
        .then((response) => {
          //console.error(response.data.PackagePrice);
          this.$notify({
            type: "success",
            placement: "top-left",
            title: "Saved Price Interval Successfully",
          });
          this.closeModal();
          this.loading = true;
          this.loadPriceInterval();
        })
        .catch((error) => {
          if (error.response) {
            this.updatePostErrors(error.response.data.errors);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
        })
        .finally(() => {
          this.disableButtons = false;
        });
    },
    updatePostErrors(errors) {
      console.log("updatePostErrors");
      console.log(errors);
      this.postErrors = errors;
    },
    save(moveToNextStatus) {
      this.disableButtons = true;
      var url = "/core/priceInterval/" + this.priceInterval.Id;
      axios
        .post(url, {
          Amount: this.priceInterval.Amount,
          StartDate: this.priceInterval.StartDate,
          RenewalStartDate: this.priceInterval.RenewalStartDate,
          StatusNote: this.priceInterval.CurrentStatusNote,
          MoveToNextStatus: moveToNextStatus,
        })
        .then((response) => {
          //console.error(response.data.PackagePrice);
          this.$notify({
            type: "success",
            placement: "top-left",
            title: "Saved Price Interval Successfully",
          });
          this.closeModal();
          this.loading = true;
          this.loadPriceInterval();
        })
        .catch((error) => {
          if (error.response) {
            this.updatePostErrors(error.response.data.errors);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
        })
        .finally(() => {
          this.disableButtons = false;
        });
    },
  },
  computed: {
    hasErrors() {
      return this.errors.any();
    },
    needsNote() {
      if (this.priceInterval.IsNoteRequired === true) {
        return "required|min:4";
      }
      return "";
    },
    modalName() {
      return "editPriceIntervalModal" + this.priceInterval.Id;
    },
  },
  data() {
    return {
      loading: true,
      priceInterval: null,
      postErrors: null,
      disableButtons: false,
      collapseSection: true,
      isCurrent: false,
      isScheduled: false,
    };
  },
};
</script>
